export class ProductNumberCommandModel {
    public productNumberId: string;
    public productNumberTypeCode: string;
    public productNumber: string;
    public providerId: string;
    public providerCode: string;
    public supplierId: string;
    public displaySequence: number;  
}